// @flow
import {trigger as edapTrigger} from './edapWrapper';

export const SEARCH_RESULT_SET_PRESENTED = 'search_result_set.presented';

export const triggerSearchResultSetPresentedEdapEvent = () => {
    const data = {
        action_location: 'search'
    };

    const option = {
        delayProcessing: false
    };

    edapTrigger(SEARCH_RESULT_SET_PRESENTED, data, option);
};
